import React, { Component } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle, faRecycle, faSlash, faUserEdit, faFileImport, faMinusCircle, faPen, faChevronUp, faChevronDown, faCheck, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {
  Box, Text, Button, ButtonGroup, Center, Spacer, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Table, Thead,
  Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Editable, EditableInput, EditableTextarea, EditablePreview, VStack, HStack, Input, Divider
} from '@chakra-ui/react';
import DataListGrid from "./ListGrid.jsx";
import ListDetailGrid from "./ListDetailGrid.jsx";
import { formatISO } from "date-fns";

import ConfigService from "../../../services/ConfigService.js";
import CoreService from "../../../services/CoreService.js";

import IdentityService from "../../../services/IdentityService.js";

import ServiceResponse from "../../../models/ServiceResponse.js";
import { AppSecurityKey } from "../../../models/AppSecurityKey.js";
import RoleManager from "../../../models/RoleManager.js";
import ListImportModal from "./ListImportModal.jsx";


const DelSwal = withReactContent(Swal);


export default class ListPanel extends Component {
  constructor(props) {
    super(props);

    this.configService = new ConfigService();
    this.coreService = new CoreService();

    this.state = {
      editMode: "add",
      listData: null,
      subListData: null,
      currentList: null,
      isLoadingGrid: false,
      isModalOpen: false,
      modalErrMsg: "",
      listName: '',
      description: '',
      modalData: [{ name: 'Big', id: 'Boy' }, { name: 'little', id: 'man' }],
      isAddRow: false,
      rowToEdit: '',
      isEditRowMode: false,
      editName: '',
      editId: '',
      isImportModalOpen: false
    };

    this.refreshData = this.refreshData.bind(this);

    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);
    this.onEditRequest = this.onEditRequest.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);


    this.onPostRequest = this.onPostRequest.bind(this);
    this.validate = this.validate.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.displayModalTable = this.displayModalTable.bind(this);

    this.onChangeModalValue = this.onChangeModalValue.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.submitNewRow = this.submitNewRow.bind(this);
    this.removeNewRow = this.removeNewRow.bind(this);
    this.setSubListGrid = this.setSubListGrid.bind(this);

    this.moveEntryUp = this.moveEntryUp.bind(this);
    this.moveEntryDown = this.moveEntryDown.bind(this);
    this.editRow = this.editRow.bind(this);

    this.onImportRequest = this.onImportRequest.bind(this);
    this.closeImportModal = this.closeImportModal.bind(this);
    this.onPostImportRequest = this.onPostImportRequest.bind(this);


  }

  async componentDidMount() {
    await this.refreshData();
  }

  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var gridDataResponse = await this.coreService.fetchIdNameMetaDataList(this.props.userSession.gcid, this.props.userSession.token);
    if (gridDataResponse.hasError) {
      this.props.onErrorPageRequest("Error fetching Data Lists.");
      return;
    }
    await this.setSubListGrid();
    var allLists = gridDataResponse.dataResult;
    // supress system lists
    var systemLists = this.configService.getSystemLists();
    var displayLists = allLists.filter(list => !systemLists.includes(list.listName));

    console.log("List Data:");
    console.info(displayLists);
    this.setState({
      listData: displayLists,
      selectedRow: null, // reset
      isLoadingGrid: false,
      syncing: false
    });
  }

  onRowSelectChange(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    var newActiveStatus = newSelectedRow.enabled;

    this.setState({
      currentList: newSelectedRow,
      activeStatus: newActiveStatus,
      listName: newSelectedRow.listName,
      description: newSelectedRow.description,
      modalErrMsg: ""
    }, () => {
      this.setSubListGrid()
    });

  }

  async setSubListGrid() {
    if (this.state.currentList) {
      var gridDataResponse = await this.coreService.fetchIdNameDataList(this.state.currentList.listName, this.props.userSession.gcid, this.props.userSession.token);
      var newGridData = gridDataResponse.dataResult.data;
      this.setState({
        subListData: newGridData
      });
    }
  }

  onNewRequest() {
    this.setState({
      editMode: "add",
      isModalOpen: true,
      modalData: [],
      listName: "",
      description: "",
      modalErrMsg: ""
    });
  }


  onImportRequest()
  {

    DelSwal.fire
    (
      {
        icon: "question",
        title: "Import Data?",
        text: "Confirm you want to overwrite the existing data for  list " + this.state.currentList.listName + ".",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel"
      }
    ).then(async (result) => {
      if (result.value) {
        this.setState({
          isImportModalOpen: true,
          inModalSession: false
        });
      }
    }
    );
  }



  closeImportModal()
  {
    this.setState({isImportModalOpen: false});
  }

  async onPostImportRequest(dataList)
  {
    var postObj = {
      metaData:
      {
        id: this.state.currentList.id,
        gcid: this.props.userSession.gcid,
        listName: this.state.listName,
        description: this.state.description,
        modelVersion: (parseInt(this.state.currentList.modelVersion) + 1) + ".0",
        storageFormat: "Json",
        storageSchema: "IdNameData",
        active: true,
        lastUpdated: formatISO(new Date()),
        lastUpdatedBy: this.props.userSession.uid,
        lastUpdatedNote: "updated by " + this.props.userSession.uid
      },
      data: dataList
    };

    var serviceResponse = this.validate(postObj, false);

    if (serviceResponse.hasError) {
      this.setState({ modalErrMsg: serviceResponse.messages });
      return;
    }
    var postResult = await this.coreService.postIdNameDataList(postObj, this.props.userSession.gcid, this.props.userSession.token);
    if (postResult.hasError) {
      this.setState({ modalErrMsg: postResult.messages });
      return;
    }

    this.closeImportModal();

    var toastMsg = "List " + postObj.metaData.listName + " has been updated. Users must log out and back in for changes to take effect."
    this.props.onToastRequest("information", toastMsg);
    await this.refreshData();
    

  }





  // #region Modal events

  displayModalTable() {
    var mapTable = [];
    var editMode = this.state.isEditRowMode
    var editIndex = this.state.rowToEdit
    var rowEditIcon
    var rowCellName
    var rowCellId
    this.state.modalData.map((entry, index) => {
      if (editMode && index == editIndex) {
        rowCellName = <Input placeholder={entry.name} onChange={(e) => this.onChangeEditRow('name', e.target.value)} />
        rowCellId = <Input placeholder={entry.id} onChange={(e) => this.onChangeEditRow('id', e.target.value)} />
        rowEditIcon = faCheck
      } else {
        rowCellName = entry.name
        rowCellId = entry.id
        rowEditIcon = faPen
      }
      mapTable.push(

        <Tr key={index}>
          <Td>
            <VStack>
              <FontAwesomeIcon icon={faChevronUp} onClick={() => this.moveEntryUp(index)} />
              <FontAwesomeIcon icon={faChevronDown} onClick={() => this.moveEntryDown(index)} />
            </VStack>
          </Td>
          <Td id={index + 'name'}>{rowCellName}</Td>
          <Td id={index + 'id'}>{rowCellId}</Td>
          <Td><FontAwesomeIcon icon={faMinusCircle} onClick={() => this.removeNewRow(index)} /></Td>
          <Td><FontAwesomeIcon icon={rowEditIcon} onClick={(e) => this.editRow(e, index)} /></Td>
        </Tr>
      )
    })
    return mapTable;
  }

  onChangeModalValue(e) {
    var newState = {};
    newState[e.target.id] = e.target.value.trim();
    this.setState(newState);
  }

  onChangeEditRow(type, value, index) {
    if (type === 'name') {
      this.setState({ editName: value })
    } else if (type === 'id') {
      this.setState({ editId: value })
    }

  }

  addNewRow() {
    this.setState({
      isAddRow: true
    })
  }

  removeNewRow(index) {
    var tempTable = this.state.modalData.filter((_, i) => i !== index)

    this.setState({
      modalData: tempTable
    })
  }

  submitNewRow(value) {
    var newTableValue
    var tempTable = this.state.modalData
    if (value) {
      newTableValue = {
        name: value,
        id: value
      }
    }
    tempTable.push(newTableValue)
    this.setState({
      modalData: tempTable,
      isAddRow: false
    })
  }

  async onEditRequest() {
    if (!this.state.currentList) {
      DelSwal.fire({ icon: "error", title: "Edit List", text: "Select a list first!" });
      return;
    }
    if (!this.state.subListData)
    {
      await this.setSubListGrid();
    }
    this.setState({
      editMode: "update",
      isModalOpen: true,
      modalData: this.state.subListData
    });
  }

  moveEntryUp(index) {
    var tempData = this.state.modalData
    if (index !== 0) {
      tempData.splice(index - 1, 0, tempData.splice(index, 1)[0]);
    }
    this.setState({
      modalData: tempData
    })
  }

  moveEntryDown(index) {
    var tempData = this.state.modalData
    if ((index + 1) !== 0) {
      tempData.splice(index + 1, 0, tempData.splice(index, 1)[0]);
    }
    this.setState({
      modalData: tempData
    })
  }

  editRow(e, index) {
    console.log(this.state.modalData[index])
    console.log(document.getElementById(index + 'name'))

    var tempData = this.state.modalData
    if (this.state.isEditRowMode == false) {
      this.setState({
        rowToEdit: index,
        isEditRowMode: true,
        editName: tempData[index].name,
        editId: tempData[index].id
      })
    } else {
      tempData[index].name = this.state.editName
      tempData[index].id = this.state.editId
      this.setState({
        modalData: tempData,
        isEditRowMode: false
      })
    }
  }



  // #endregion Modal events


  // #region Post Modal

  closeModal() {

    this.setState({
      isModalOpen: false
    })

  }

  async onPostRequest() {
    var isAddMode = (this.state.editMode === "add");
    var postObj = {
      metaData:
      {
        id: (isAddMode) ? IdentityService.makeUuid() : this.state.currentList.id,
        gcid: this.props.userSession.gcid,
        listName: this.state.listName,
        description: this.state.description,
        modelVersion: (isAddMode) ? "1.0" : (parseInt(this.state.currentList.modelVersion) + 1) + ".0",
        storageFormat: "Json",
        storageSchema: "IdNameData",
        active: true,
        lastUpdated: formatISO(new Date()),
        lastUpdatedBy: this.props.userSession.uid,
        lastUpdatedNote: "updated by " + this.props.userSession.uid
      },
      data: this.state.modalData
    };

    console.group("Post Object");
    console.info(postObj);
    console.groupEnd();

    var serviceResponse = this.validate(postObj, isAddMode);
    console.group("Validation Response");
    console.info(serviceResponse);
    console.groupEnd();
    if (serviceResponse.hasError) {
      this.setState({ modalErrMsg: serviceResponse.messages });
      //this.props.onMsgBoxRequest("Problem", serviceResponse.messages, "error", "return");
      return;
    }
    var postResult = await this.coreService.postIdNameDataList(postObj, this.props.userSession.gcid, this.props.userSession.token);
    if (postResult.hasError) {
      this.setState({ modalErrMsg: postResult.messages });
      return;
    }
    this.closeModal();
    var toastMsg = (isAddMode) ? "List " + postObj.metaData.listName + " has been created. Users must log out and back in for changes to take effect."
      : "List " + postObj.metaData.listName + " has been updated. Users must log out and back in for changes to take effect."
    this.props.onToastRequest("information", toastMsg);
    await this.refreshData();

  }



  // return ServiceResponse
  validate(postObj, isAddMode) {
    var result = new ServiceResponse(false, []);
    // confirm that we have both a listname AND a description
    if ((postObj.metaData.listName === "") || (postObj.metaData.description === "")) {
      result.hasError = true;
      result.messages.push("You must include a new datalist name and description!");
      return result;
    }
    if (isAddMode) {
      // confirm we don't ALREADY have a datalist with this listName
      if (this.state.listData.some((l) => l.listName === postObj.metaData.listName)) {
        result.hasError = true;
        result.messages.push(postObj.metaData.listName + " already exists in your datalists. Please give it a different name!");
        return result;
      }
    }

    if ((!postObj.data) || (postObj.data.length < 1)) {
      result.hasError = true;
      result.messages.push("You must save at least one datalist item with your list!");
      return result;
    }


    if (postObj.data.some((m) => (m.name.trim() === "") || (m.id.trim() === ""))) {
      result.hasError = true;
      result.messages.push("Each datalist item must have a name and a value!");
      return result;
    }

    return result;
  }


  async onDeleteRequest() {
    if (!this.state.currentList) {
      DelSwal.fire({ icon: "error", title: "Remove List", text: "Select a list to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove List?",
          text: "Confirm you want to permanently remove the existing list " + this.state.currentList.listName + ". Note that if this list is used as a source list for a schema, this could result in no data showing up.",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.coreService.postIdNameDataListDeleteRequest(this.state.currentList.listName, this.props.userSession.gcid, this.props.userSession.token);
          await this.refreshData();
          var currentListName = this.state.currentList.listName;
          this.setState({ currentUser: null });
          return DelSwal.fire({ icon: "success", text: currentListName + " has been permanently deleted." });
        }
      }
      );
  }

  // #endregion Post modal


  render() {
    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    var hasAddRights = RoleManager.hasRoleRights(AppSecurityKey.ADD_DATALISTS, this.props.userSession.token);
    var hasDeleteRights = RoleManager.hasRoleRights(AppSecurityKey.DELETE_DATALISTS, this.props.userSession.token);

    return (
      <Center id="admin-panel">


          <ListImportModal
                isOpen = {this.state.isImportModalOpen}
                userSession={this.props.userSession}
                schemaId={this.state.currentLookupEntity?.schemaId ?? ""}
                observationSessionMode={this.state.sessionMode}
                onToastRequest = {this.props.onToastRequest}
                onMsgBoxRequest = {this.props.onMsgBoxRequest}
                inModalSession = {this.state.inModalSession}
                onPostRequest = {this.onPostImportRequest}
                onCloseRequest = {this.closeImportModal}

          />



        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.closeModal()}
          scrollBehavior='inside'
          size='3xl'
          fontSize='14px'
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{this.state.editMode} {this.state.editMode === "add" ? "new data list" : this.state.currentList.description}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>

              <HStack justify='space-evenly'>
                <Box width="46%">
                  <Text margin='0' fontSize='12px'>list name</Text>
                  <Input
                    id="listName"
                    placeholder={this.state.editMode === "add" ? "add list name" : this.state.currentList.listName}
                    onChange={(e) => { this.onChangeModalValue(e) }}
                  />
                </Box>

                <Box width="48%">
                  <Text margin='0' fontSize='12px'>description</Text>
                  <Input
                    id="description"
                    placeholder={this.state.editMode === "add" ? "add description" : this.state.currentList.description}
                    onChange={(e) => { this.onChangeModalValue(e) }}
                  />
                </Box>
              </HStack>

              <Divider />

              <TableContainer>
                <Table
                  variant='simple'
                  size='sm'
                >
                  <TableCaption>
                    {this.state.isAddRow
                      ? <Editable
                        defaultValue="type new value and press enter"
                        startWithEditView={true}
                        onSubmit={this.submitNewRow}
                      >
                        <EditablePreview />
                        <EditableInput />
                      </Editable>
                      : ""
                    }
                  </TableCaption>
                  <Thead>
                    <Tr>
                      <Th></Th>
                      <Th>name</Th>
                      <Th>value</Th>
                      <Th></Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {this.displayModalTable()}
                  </Tbody>

                </Table>
              </TableContainer>
            </ModalBody>
            <ModalFooter>
              {(this.state.modalErrMsg !== "") ?
                <FontAwesomeIcon color="red" icon={faExclamationCircle} />
                : <span />
              }
              <Text color="red">{this.state.modalErrMsg}</Text>
              <Spacer />
              
                <Button
                  leftIcon={<FontAwesomeIcon icon={faPlusCircle} size="lg" />}
                  colorScheme="blue"
                  onClick={() => this.addNewRow()}
                  marginRight={"20%"}
                >
                  add new
                </Button>
              
              <Button colorScheme='blue' mr={3} onClick={() => this.onPostRequest()}>
                submit
              </Button>
              <Button colorScheme='blue' mr={3} onClick={() => this.closeModal()}>
                cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Box bgColor='#0a597e' borderRadius='5px' width="100%" padding='20px'>

          <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Data Lists</Text>

          <DataListGrid
            userSession={this.props.userSession}
            onToastRequest={this.props.onToastRequest}
            onErrorPageRequest={this.props.onErrorPageRequest}
            rowData={this.state.listData}
            onRowSelectChange={this.onRowSelectChange}
            onEditRequest={this.onEditRequest}
          />
          <Center margin='10px'>

<ButtonGroup isAttached>
  {hasAddRights &&
    <Button
      variant="solid"
      leftIcon={<FontAwesomeIcon icon={faPlusCircle} />}
      bg='#0095c8'
      color='white'
      fontSize={{ base: '12px', md: '14px', lg: '18px' }}
      onClick={this.onNewRequest}
    >
      New
    </Button>
  }

  <Button
    variant="solid"
    leftIcon={<FontAwesomeIcon icon={faUserEdit} />}
    bg='#0095c8'
    color='white'
    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
    onClick={(e) => this.onEditRequest(e)}
  >
    Edit
  </Button>


  {hasDeleteRights &&
    <Button
      variant="solid"
      leftIcon={<FontAwesomeIcon icon={faSlash} />}
      bg='#0095c8'
      color='white'
      fontSize={{ base: '12px', md: '14px', lg: '18px' }}
      onClick={this.onDeleteRequest}
    >
      Delete
    </Button>
  }


  <Button
    variant="solid"
    leftIcon={<FontAwesomeIcon icon={faRecycle} />}
    bg='#0095c8'
    color='white'
    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
    onClick={(e) => this.refreshData(e)}
  >
    Refresh
  </Button>
</ButtonGroup>
{loadingGridIcon}
</Center>

          {this.state.currentList &&


            <ListDetailGrid
              userSession={this.props.userSession}
              onToastRequest={this.props.onToastRequest}
              onErrorPageRequest={this.props.onErrorPageRequest}
              currentList={this.state.currentList}
              subList={this.state.subListData}
              onImportRequest={this.onImportRequest}
            />

          }

        </Box>
      </Center>
    );
  }
}
